
import React, { useState } from 'react';
import { Card, CardContent } from "@/components/ui/card";
import { toast } from "sonner";
import { loansData } from './utils';
import { LoansList } from './LoansList';
import { AddLoanDialog } from './AddLoanDialog';
import { LoanDetails } from './LoanDetails';
import { DebtManagementHeader } from './DebtManagementHeader';
import { useLoanFilters } from './hooks/useLoanFilters';
import { Loan } from './types/loans';

export const DebtManagement = () => {
  const [showAddLoanDialog, setShowAddLoanDialog] = useState(false);
  const [selectedLoan, setSelectedLoan] = useState<number | null>(null);
  const [mainView, setMainView] = useState<"loans" | "loan-details">("loans");
  const [selectedTab, setSelectedTab] = useState("security");

  // Sample data - this would come from an API in a real app
  const loans = loansData as Loan[];
  
  // Use the custom hook for filtering loans
  const {
    searchQuery,
    setSearchQuery,
    statusFilter,
    setStatusFilter,
    typeFilter,
    setTypeFilter,
    viewType,
    setViewType,
    filteredLoans
  } = useLoanFilters({ loans });

  // Handle adding a new loan
  const handleAddLoan = () => {
    toast.success("New borrowing added successfully");
    setShowAddLoanDialog(false);
    // In a real app, this would add the loan to the database
  };

  // Handle view details
  const handleViewDetails = (loan: Loan) => {
    setSelectedLoan(loan.id);
    setMainView("loan-details");
    setSelectedTab("security"); // Default to security tab when viewing loan details
  };
  
  // Handle back to loans list
  const handleBackToLoansList = () => {
    setMainView("loans");
    setSelectedLoan(null);
  };
  
  // Get current loan data
  const currentLoan = selectedLoan !== null 
    ? loans.find(l => l.id === selectedLoan) || null
    : null;
  
  return (
    <div className="space-y-6">
      <Card>
        <DebtManagementHeader 
          mainView={mainView}
          currentLoan={currentLoan}
          showAddLoanDialog={showAddLoanDialog}
          setShowAddLoanDialog={setShowAddLoanDialog}
          handleAddLoan={handleAddLoan}
          handleBackToLoansList={handleBackToLoansList}
        />
        <CardContent>
          {mainView === "loans" && (
            <LoansList
              viewType={viewType}
              setViewType={setViewType}
              searchQuery={searchQuery}
              setSearchQuery={setSearchQuery}
              statusFilter={statusFilter}
              setStatusFilter={setStatusFilter}
              typeFilter={typeFilter}
              setTypeFilter={setTypeFilter}
              filteredLoans={filteredLoans}
              selectedLoan={selectedLoan}
              setSelectedLoan={setSelectedLoan}
              handleViewDetails={handleViewDetails}
            />
          )}
          {mainView === "loan-details" && currentLoan && (
            <LoanDetails
              currentLoan={currentLoan}
              selectedTab={selectedTab}
              setSelectedTab={setSelectedTab}
              handleGenerateReport={() => toast.success("Report generated successfully")}
            />
          )}
          {mainView === "loan-details" && !currentLoan && (
            <div className="lg:col-span-2 flex items-center justify-center h-full">
              {/* Empty state when no borrowing is selected */}
              <p className="text-muted-foreground">Select a borrowing to view details</p>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
};
